/* eslint-disable no-restricted-syntax */
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import {
  UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';
import _ from 'lodash';
import moment from 'moment';

import SweetAlert from 'react-bootstrap-sweetalert';
import Table from '../../../../components/table/Table';
import Form from '../../../../components/form/form';

import ROUTES from '../../../../config/routes';

import {
  getQRCodeConfig, getAllQRCodes, deleteQRCodeConfig, translateQRCode,
} from '../../../../app/store/actions/QRCodeConfig';
import addNotification from '../../../../components/notification';

class QRCodeConfigList extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      QRs: [],
      showModalDelete: false,
      QRCodeConfigDelete: null,
      QRCodeConfig: null,
      testModel: '',
      showTestModal: false,
      showTestResult: false,
      testProductCode: '',
      testLotNumber: '',
      testExpirationDate: '',
      testManufacturingDate: '',
      testQuantity: '',
    };

    this.defaultSorted = [
      {
        id: 'code',
        desc: false,
      },
    ];

    this.tableColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            <button type="button" className="btn btn-default btn-xs">{I18n.t('BEE55' /* Ações */)}</button>
            <UncontrolledButtonDropdown>
              <DropdownToggle color="default" caret className="btn-xs" />
              <DropdownMenu>
                <DropdownItem onClick={() => this.showQRCodeConfigDetail(rows.row)}>
                  {I18n.t('BEE56' /* Detalhes */)}
                </DropdownItem>
                <DropdownItem onClick={() => this.showEditQRCodeConfig(rows.row)}>
                  {I18n.t('BEE57' /* Editar */)}
                </DropdownItem>
                <DropdownItem onClick={() => this.showCopyQRCodeConfig(rows.row)}>
                  {I18n.t('BEE80' /* Copiar */)}
                </DropdownItem>
                <DropdownItem onClick={() => this.showDeleteQRCodeConfig(rows.row)}>
                  {I18n.t('BEE81' /* Eliminar */)}
                </DropdownItem>
                <DropdownItem onClick={() => this.showTestModal(rows.row)}>
                  {I18n.t('BEE4595' /* Testar modelo */)}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        ),
      }, {
        Header: I18n.t('BEE82' /* Código */),
        accessor: 'code',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 60,
      }, {
        Header: I18n.t('BEE1092' /* Separador */),
        accessor: 'separator',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 60,
      }, {
        Header: I18n.t('BEE1897' /* Descrição */),
        accessor: 'description',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
      }, {
        Header: I18n.t('BEE4854' /* Padrão UDI */),
        accessor: 'usesUdiStandard',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? I18n.t('BEE172' /* Sim */) : I18n.t('BEE173' /* Não */)}
          </span>
        ),
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const id = row[filter.id];
          if (_.includes('sim', input)) {
            return id === true;
          } if (_.includes('nao', input)) {
            return id === false;
          }
        },
      },
    ];
  }

  componentDidMount() {
    this.maintainsState();
  }

  setInitState = () => {
    this.setState({
      showModalDelete: false,
      QRCodeConfigDelete: null,
    });
  };

  maintainsState = async () => {
    if (this.props.location.state && this.props.location.state.dice) {
      this.setState({
        page: this.props.location.state.dice.page,
        firstRun: true,
      });
    }

    await this.getAllQRCodes();
  };

  setValue = async (attr, value) => {
    await this.setState({
      [`${attr}`]: value,
    });
  };

  getAllQRCodes = async () => {
    const QRs = await this.props.getAllQRCodes() || [];

    await this.setState({
      QRs,
    });
  };

  showQRCodeConfigDetail = (QRCodeConfig) => {
    this.props.history.push({
      pathname: ROUTES.QR_CODE_CONFIG_DETAIL,
      state: {
        QRCodeConfig: QRCodeConfig._original,
      },
    });
  };

  showEditQRCodeConfig = (QRCodeConfig) => {
    this.props.history.push({
      pathname: ROUTES.QR_CODE_CONFIG_EDIT,
      state: {
        QRCodeConfig: QRCodeConfig._original,
      },
    });
  };

  showCopyQRCodeConfig = (QRCodeConfig) => {
    this.props.history.push({
      pathname: ROUTES.QR_CODE_CONFIG_COPY,
      state: {
        QRCodeConfig: QRCodeConfig._original,
      },
    });
  };

  showTestModal = (QRCodeConfig) => {
    this.setState({
      showTestModal: true,
      QRCodeConfig: QRCodeConfig._original,
    });
  };

  deleteQRCodeConfig = async (QRCodeConfig) => {
    try {
      await this.props.deleteQRCodeConfig(QRCodeConfig._original.id);
      await this.setInitState();

      addNotification(
        'success',
        I18n.t('BEE4607' /* Remover Configurador de QR Code */),
        I18n.t('BEE4608' /* Configurador de QR Code removido com sucesso! */),
        'top-right',
      );
      await this.getAllQRCodes();
    } catch (err) {
      await this.setInitState();
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE4607' /* Remover Configurador de QR Code */),
            `${error.code} - ${error.message || error.details}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE4607' /* Remover Configurador de QR Code */),
            I18n.t('BEE4609' /* Erro ao remover o Configurador de QR Code. */),
            'top-right',
          );
        }
      }
    }
  };

  showDeleteQRCodeConfig = (QRCodeConfig) => {
    this.setState({ showModalDelete: true, QRCodeConfigDelete: QRCodeConfig });
  };

  clearTestModal = () => {
    this.setState({ testModel: '', showTestModal: false, showTestResult: false });
  };

  showTestResult = async () => {
    const { testModel, QRCodeConfig } = this.state;

    if (testModel) {
      try {
        if (QRCodeConfig.usesUdiStandard) {
          const parsed = await this.props.translateQRCode(testModel, QRCodeConfig);

          if (parsed) {
            this.setState({
              testProductCode: parsed.ean || '',
              testLotNumber: parsed.lotNumber || '',
              testExpirationDate: parsed.expirationDate || '',
              testManufacturingDate: parsed.manufacturingDate || '',
              testQuantity: parsed.quantity || '',
              showTestResult: true,
            });
          }
          return;
        }

        const cleanModel = testModel.startsWith(QRCodeConfig.separator)
          ? testModel.slice(1)
          : testModel;
        const splitModel = cleanModel.split(QRCodeConfig.separator);

        const expirationDateFormated = QRCodeConfig.expirationDatePosition ? this.parseDateFromFormat(
          splitModel[QRCodeConfig.expirationDatePosition - 1],
          QRCodeConfig.expirationDateFormat,
        ) : '';

        const manufacturingDateFormated = QRCodeConfig.manufacturingDatePosition ? this.parseDateFromFormat(
          splitModel[QRCodeConfig.manufacturingDatePosition - 1],
          QRCodeConfig.manufacturingDateFormat,
        ) : '';

        this.setState({
          testProductCode: splitModel[QRCodeConfig.productCodePosition - 1],
          testLotNumber: splitModel[QRCodeConfig.lotNumberPosition - 1],
          testQuantity: splitModel[QRCodeConfig.quantityPosition - 1],
          testExpirationDate: expirationDateFormated,
          testManufacturingDate: manufacturingDateFormated,
          showTestResult: true,
        });
      } catch (err) {
        await addNotification(
          'danger',
          I18n.t('BEE4590' /* Configurador de QR Code */),
          I18n.t('BEE4606' /* Leitura inválida! */),
          'top-right',
        );
      }
    }
  };

  keypressShowTestResult = (e, id, attr) => {
    if (e.keyCode === 13) {
      if (attr === 'testModel') this.showTestResult();
    }
  };

  parseDateFromFormat = (value, format) => {
    const cleanValue = value.replace(/\D/g, '');
    const cleanFormat = format.toUpperCase().replace(/[^DMAY]/g, '');

    const groups = cleanFormat.match(/(D+|M+|A+|Y+)/g);

    let index = 0;
    let day = '';
    let month = '';
    let year = '';

    for (const group of groups) {
      const { length } = group;
      const part = cleanValue.substr(index, length);

      switch (group[0]) {
        case 'D':
          day = part;
          break;

        case 'M':
          month = part;
          break;

        case 'A':
        case 'Y':
          year = part.length === 2 ? `20${part}` : part;
          break;

        default:
          break;
      }

      index += length;
    }

    day = day.padStart(2, '0');
    month = month.padStart(2, '0');

    return `${day}/${month}/${year}`;
  };

  render() {
    const {
      QRs = [],
      page,
      showModalDelete,
      QRCodeConfigDelete,
      testModel,
      showTestModal,
      testProductCode,
      testLotNumber,
      testExpirationDate,
      testManufacturingDate,
      testQuantity,
      showTestResult,
    } = this.state;

    return (
      <div>
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE1389' /* Cadastros */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE14' /* Gerais */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE4590' /* Configurador de QR Code */)}</li>
          </ol>
        </div>
        <Table
          downloadCSV
          headerTitle={I18n.t('BEE4590' /* Configurador de QR Code */)}
          actionButtons={(
            <div className="ml-auto">
              <Link to={ROUTES.QR_CODE_CONFIG_CREATE} className="btn btn-success btn-sm btn-rounded pl-2 pr-3">
                <i className="fa fa-plus mr-1" />
                {I18n.t('BEE2882' /* Incluir */)}
              </Link>
            </div>
          )}
          panelHeaderProps={{
            onClickReload: this.getAllQRCodes,
          }}
          filterable
          data={QRs}
          columns={this.tableColumns}
          expander
          defaultPageSize={10}
          defaultSorted={this.defaultSorted}
          page={(page) || (
            (!this.state.firstRun && this.props.location.state
              && this.props.location.state.dice && this.props.location.state.dice.page)
              ? this.props.location.state.dice.page : page)}
          onPageChange={(Page) => ((Page >= 0) ? this.setState({ page: Page }) : this.setState({ page: 0 }))}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
        />
        {(showModalDelete
          && (
            <SweetAlert
              danger
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE100' /* Confirmar */)}
              confirmBtnBsStyle="danger"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE101' /* Você tem certeza? */)}
              onConfirm={() => this.deleteQRCodeConfig(QRCodeConfigDelete)}
              onCancel={() => this.setInitState()}
            >
              {I18n.t('BEE4617', {
                0: QRCodeConfigDelete._original.code,
              } /* O modelo de QR Code %{0} será eliminado! */)}
            </SweetAlert>
          )
        )}
        {(showTestModal
          && (
            <SweetAlert
              confirmBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnBsStyle="default"
              title={I18n.t('BEE4595' /* Testar modelo */)}
              onConfirm={this.clearTestModal}
              onCancel={this.clearTestModal}
            >
              <form className="mt-4 pr-4" onSubmit={(e) => e.preventDefault()} noValidate>
                <Form
                  noPanel
                  setValue={this.setValue}
                  inputs={(formContext) => ([
                    formContext.createInputButton(
                      testModel,
                      'testModel',
                      '',
                      '',
                      'text',
                      false,
                      false,
                      I18n.t('BEE4596' /* Testar */),
                      this.showTestResult,
                      this.keypressShowTestResult,
                      1,
                    ),
                    ...(showTestResult ? [
                      formContext.createInput(
                        testProductCode,
                        'testProductCode',
                        I18n.t('BEE378' /* Código do Produto */),
                        '',
                        'text',
                        false,
                        true,
                      ),
                      formContext.createInput(
                        testLotNumber,
                        'testLotNumber',
                        I18n.t('BEE1091' /* Número do lote */),
                        '',
                        'text',
                        false,
                        true,
                      ),
                      formContext.createInput(
                        testExpirationDate,
                        'testExpirationDate',
                        I18n.t('BEE2035' /* Data Vencimento */),
                        '',
                        'text',
                        false,
                        true,
                        testExpirationDate && !moment(testExpirationDate, 'DD/MM/YYYY', true).isValid()
                          ? { content: I18n.t('BEE2363' /* Data Inválida */) }
                          : false,
                      ),
                      formContext.createInput(
                        testManufacturingDate,
                        'testManufacturingDate',
                        I18n.t('BEE488' /* Data de Fabricação */),
                        '',
                        'text',
                        false,
                        true,
                        testManufacturingDate && !moment(testManufacturingDate, 'DD/MM/YYYY', true).isValid()
                          ? { content: I18n.t('BEE2363' /* Data Inválida */) }
                          : false,
                      ),
                      formContext.createInput(
                        testQuantity,
                        'testQuantity',
                        I18n.t('BEE441' /* Quantidade */),
                        '',
                        'text',
                        false,
                        true,
                      ),
                    ] : []),
                  ])}
                />
              </form>
            </SweetAlert>
          ))}
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  getAllQRCodes: () => dispatch(getAllQRCodes()),
  getQRCodeConfig: (qrCodeConfigId) => dispatch(getQRCodeConfig(qrCodeConfigId)),
  deleteQRCodeConfig: (qrCodeConfigId) => dispatch(deleteQRCodeConfig(qrCodeConfigId)),
  translateQRCode: (qrCodeString, qrCodeConfig) => dispatch(translateQRCode(qrCodeString, qrCodeConfig)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(QRCodeConfigList));
